import React from 'react';
import styled from 'styled-components';

import { unitsTypes } from '../../../../constants/dashboards';
import UnitBuilderCreateHeader from '../../../../containers/dashboards/cards/builder/UnitBuilderCreateHeader';
import UsersView from '../../../../containers/dashboards/cards/builder/users/Users';
import RetentionComposeContainer from '../../../../containers/dashboards/cards/builder/retention/RetentionComposeContainer';
import RetentionSimplifiedComposeContainer from '../../../../containers/dashboards/cards/builder/retentionSimple/RetentionSimplifiedComposeContainer';
import FunnelUpdatePaneContainer from '../../../../containers/dashboards/cards/builder/funnels/PaneContainer';
import RevenueView from './revenue/RevenueView';
import EventsView from '../../../../containers/dashboards/cards/builder/event/ViewContainer';

const StyledUnitBuilderContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const UnitBuilderByType = (props) => {
  const { unit, showNotValidFields } = props;

  switch (unit.type) {
    case unitsTypes.EVENTS_TYPE:
      return <EventsView {...props} />;
    case unitsTypes.RETENTION_TYPE:
      return <RetentionSimplifiedComposeContainer unitId={unit.id} />;
    case unitsTypes.RETENTION_COMPLEX_TYPE:
      return <RetentionComposeContainer unitId={unit.id} showNotValidFields={showNotValidFields} />;
    case unitsTypes.USERS_TYPE:
      return <UsersView {...props} />;
    case unitsTypes.REVENUE_TYPE:
      return <RevenueView {...props} />;
    case unitsTypes.FUNNELS_TYPE:
      return <FunnelUpdatePaneContainer {...props} />;
    default:
      return <div />;
  }
};

const UnitBuilder = (props) => {
  const { unit, showNotValidFields } = props;

  return (
    <StyledUnitBuilderContainer>
      <UnitBuilderCreateHeader unit={unit} {...props} />
      <UnitBuilderByType unit={unit} showNotValidFields={showNotValidFields} />
    </StyledUnitBuilderContainer>
  );
};

export default UnitBuilder;
